import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { finalize, Observable } from "rxjs";
import { LoadingOverlayService } from "./loading-overlay.service";
import { RequestStorageService } from "../request-storage-service";
import { DISABLE_LOADER } from "../helpers/header-keys";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoadingOverlayService,
    private httpRequestSorage: RequestStorageService) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let showLoader = true;

    if (req.headers?.get(DISABLE_LOADER) === "true") {
      showLoader = false;
      req = req.clone({
        headers: req.headers.delete(DISABLE_LOADER),
      });
    }

    if (showLoader && !this.loaderService.isRequestHidden) {
      this.addRequestLoading(req);
      this.loaderService.emitLoading(true);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (showLoader) {
          this.removeRequestLoading(req);
        }
      })
    );
  }

  private addRequestLoading(req: HttpRequest<any>) {
    this.httpRequestSorage.addHttpRequest(req);
  }

  private removeRequestLoading(req: HttpRequest<any>) {
    this.httpRequestSorage.removeHttpRequest(req);
    this.loaderService.emitLoading(this.httpRequestSorage.getCountRequests() > 0);
  }
}
